const TIMEOUT_DELAY_SHORT = 10;
const TIMEOUT_DELAY_LONG = 20;

function applyBoldScript(currentElement, maximum, swatchDefaultqty) {
  setTimeout(function () {
    // Find the quantity input element within the current element
    const quantityInput = currentElement.querySelector('.bold_option_value_quantity input');
    if (quantityInput) {
      // Add the 'readonly' attribute to make the input read-only
      quantityInput.setAttribute('readonly', 'true');
      var currentValue = parseInt(quantityInput.value);

      // Create increment and decrement buttons
      const incrementButton = document.createElement('button');
      incrementButton.textContent = '+';
      incrementButton.classList.add('common-button', 'increment-button');
      incrementButton.setAttribute('data-btype', 'increment');

      const decrementButton = document.createElement('button');
      decrementButton.textContent = '-';
      decrementButton.classList.add('common-button', 'decrement-button');
      decrementButton.setAttribute('data-btype', 'decrement');

      // Append the buttons to the quantity input element
      currentElement.querySelector('.bold_option_value_quantity').append(decrementButton);
      currentElement.querySelector('.bold_option_value_quantity').prepend(incrementButton);

      // Event listener for increment button
      incrementButton.addEventListener('click', function (event) {
      setTimeout(function() {
        
        currentValue++;
        quantityInput.setAttribute('value',currentValue);
        quantityInput.value = currentValue;
        const changeEvent = new Event('change', { bubbles: true });
        quantityInput.dispatchEvent(changeEvent);
        // console.log("swatchDefaultqty", swatchDefaultqty)
        var selectTotalQTY = parseInt(swatchDefaultqty);

        var incrementButtons = document.querySelectorAll('[data-btype="increment"]');
        incrementButtons.forEach(function (button) {
          var qtySelectorInfo = button.closest('.bold_option_value_quantity');
          var currentElement = button.closest('.bold_option_value');
          var selectQTYInput = qtySelectorInfo.querySelector('input');
          var selectQTY = parseInt(selectQTYInput.value);
          selectTotalQTY += selectQTY ;
          // console.log("Selected Total Quantity increase -->", selectTotalQTY);
        });
        
      if (selectTotalQTY >= maximum) {
        // console.log('maxQTY -->', maximum);
        incrementButtons.forEach(function(button) {
          button.disabled = true; // Disable the button
        });
        toggleSwatch(currentElement, false);
      }
      },20);
      
        event.preventDefault();
      
      });

      // Event listener for decrement button
      decrementButton.addEventListener('click', function (event) {
          setTimeout(function() {
        
        if (currentValue > 1) {
          currentValue--;
          quantityInput.value = currentValue;
          const changeEvent = new Event('change', { bubbles: true });
          quantityInput.dispatchEvent(changeEvent);

           var selectTotalQTY = parseInt(swatchDefaultqty);
      var incrementButtons = document.querySelectorAll('[data-btype="increment"]');
      incrementButtons.forEach(function (button) {
        var qtySelectorInfo = button.closest('.bold_option_value_quantity');
        var currentElement = button.closest('.bold_option_value');
        var selectQTYInput = qtySelectorInfo.querySelector('input');
        var selectQTY = parseInt(selectQTYInput.value);
        // console.log("Selected Quantity minus-->", selectQTY);
        selectTotalQTY += selectQTY;
        // console.log("Selected Total Quantity decrease -->", selectTotalQTY);
      });

            if (selectTotalQTY < maximum) {
              //console.log('maxQTY -->', maximum);
              incrementButtons.forEach(function(button) {
                button.disabled = false; // Enable the button
              });
               toggleSwatch(currentElement, true);
            }
        }
          }, TIMEOUT_DELAY_SHORT);
            
          event.preventDefault();
        
      });
    }
  }, TIMEOUT_DELAY_LONG);

  
}
function toggleSwatch(currentElement, enable) {
  
  setTimeout(function () {
    if (currentElement) {
      const quantityElement = currentElement.querySelector('.bold_option_value_quantity');

      if (quantityElement) {
        const Parent = quantityElement.closest('.bold_option_element');

        if (Parent) {
          const allOptions = Parent.querySelectorAll('.bold_option_value_element');

          allOptions.forEach((option) => {
            const checkbox = option.querySelector('input[type="checkbox"]');
            if (checkbox && !option.classList.contains('bold_swatch_selected')) {
              checkbox.disabled = !enable;
            }
          });
        }
      }
    }
  }, TIMEOUT_DELAY_LONG);
}

function priceTotal() {
  const totalSpan = document.querySelector('.bold_option_total span');

  if (totalSpan) {
    const totalAmount = parseFloat(totalSpan.textContent.replace('$', ''));

    if (totalAmount <= 0) {
      document.querySelector('.bold_option_total').style.display = 'none';
    } else {
      document.querySelector('.bold_option_total').style.display = 'block';
    }
  }
}

function errorMsg(event, selectTotalQTY , maximum) {
console.log(selectTotalQTY, "==",maximum);
  
  if (selectTotalQTY != maximum) {
        // event.preventDefault();
    
     const existingErrorMessage = document.querySelector('.error-message');
      if (existingErrorMessage) {
        existingErrorMessage.remove();
      }
    const errorMessage = document.createElement('div');
    errorMessage.className = 'error-message';
    errorMessage.textContent = 'Please add '+maximum+' quantities before adding to cart.';

    const parentBoldOption = document.querySelector('.bold_option_value'); // You might need to adjust this selector based on your structure
    parentBoldOption.insertAdjacentElement('beforebegin', errorMessage); // Insert above the .bold_option_value element

    // Alternatively, you can insert below the .bold_option_value element using:
    // parentBoldOption.insertAdjacentElement('afterend', errorMessage);

    event.preventDefault(); // Prevent the default behavior
    event.stopPropagation(); // Stop event propagation
    if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
      BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
    }
    return;
  } else{
     const existingErrorMessage = document.querySelector('.error-message');
      if (existingErrorMessage) {
        existingErrorMessage.remove();
      }
  }
}

function observeDOM() {
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded') ) {
           const title = document.querySelector('.section__title-text.product-single__title-text').textContent.toLowerCase();
           var maximum;
            var selectTotalQTY;
            if (title.includes("half dozen")) {
              maximum = 6;
            } 
            else if (title.includes("dozen")) {
              maximum = 12;
            }

          if (title.includes("half dozen") || title.includes("dozen")) {
              
              // Add an event listener for the checkbox change event
              const checkboxes = document.querySelectorAll('.bold_option_element input');
              checkboxes.forEach(function (checkbox) {
              console.log("yes change", checkbox)
                
                checkbox.addEventListener('change', function () {

                  const parentBoldOption = this.closest('.bold_option_value');
                       selectTotalQTY = parseInt(0);
                 
                  
                    setTimeout(function () {
                    var incrementButtons = document.querySelectorAll('[data-btype="increment"]');
                    incrementButtons.forEach(function (button) {
                      var qtySelectorInfo = button.closest('.bold_option_value_quantity');
                      var currentElement = button.closest('.bold_option_value');
                      var selectQTYInput = qtySelectorInfo.querySelector('input');
                      var selectQTY = parseInt(selectQTYInput.value);
                      console.log("Selected Quantity out-->", selectQTY);
                      selectTotalQTY += selectQTY;
                      console.log("Selected Total Quantity  -->", selectTotalQTY);
                       if (selectTotalQTY >= maximum) {
                        // console.log('maxQTY -->', maximum);
                        incrementButtons.forEach(function(button) {
                          button.disabled = true; // Disable the button
                        });
                        toggleSwatch(parentBoldOption, false);
                      }
                       if (selectTotalQTY < maximum) {
                          //console.log('maxQTY -->', maximum);
                          incrementButtons.forEach(function(button) {
                            button.disabled = false; // Enable the button
                          });
                           toggleSwatch(parentBoldOption, true);
                        }
                    });

                  }, 150);
                     setTimeout(function () {
                    applyBoldScript(parentBoldOption, maximum, selectTotalQTY);
                      }, 100);
                  priceTotal();
                
                });

              });

               const addToCartBtn = document.querySelector('.product-form__add-btn');
    
                addToCartBtn.addEventListener('click', function (event) {
                  const numberInputs = document.querySelectorAll('.bold_option_value input[type="number"]');

                            // Initialize a variable to store the total
                            let total = 0;
                            
                            // Iterate through the input elements and sum their values
                            numberInputs.forEach(input => {
                              total += parseInt(input.value) || 0;
                            });

                  errorMsg(event, total, maximum);                   
                });
            observer.disconnect();
            break;
        } 
          else{
              console.log("no Product")
            
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function () {
 setTimeout(function(){
  observeDOM();                   
   
 },0)
});